import ar from "../locale/ar";
import de from "../locale/de";
import en from "../locale/en";
import es from "../locale/es";
import fr from "../locale/fr";
import hi from "../locale/hi";
import ja from "../locale/ja";
import ko from "../locale/ko";
import pl from "../locale/pl";
import pt from "../locale/pt";
import ru from "../locale/ru";
import zhHans from "../locale/zh_Hans";
import zhHant from "../locale/zh_Hant";
import { createIntl, createIntlCache } from "react-intl";

let url = new URL(location.href);
let languageCode = (url.searchParams.get("language") || "en").trim();
if (languageCode.startsWith("zh_Hant") || ["zh_tw", "zh-HK", "zh-TW"].includes(languageCode)) {
  languageCode = "zh-Hant";
} else if (languageCode.startsWith("zh_Hans") || ["zh", "zh-CN"].includes(languageCode)) {
  languageCode = "zh-Hans";
} else if (languageCode.search("id") !== -1) {
  languageCode = "hi";
}

const message = {
  "zh-Hans": zhHans,
  "zh-Hant": zhHant,
  en: en,
  ar: ar,
  de: de,
  es: es,
  fr: fr,
  hi: hi,
  ja: ja,
  ko: ko,
  pl: pl,
  pt: pt,
  ru: ru,
}[languageCode] || en;

export const getLanguageCode = () => languageCode;
export const getCurrentMessages = () => message;

export default createIntl(
  {
    locale: languageCode,
    messages: message,
  },
  createIntlCache()
);
